import { storageRef } from "../init/firebase";
import { IUploadedFile } from "../pages/Brands/components/Media/types";

interface ILocalFileEntry {
  file: File;
  name: string;
  localUrl: string;
  path: string;
}

interface IUploadedFileEntry {
  src: string;
  path: string;
}

export const handleLocalFileEntries = (
  files: FileList | null,
  path: string,
  prependRandomText = false
): ILocalFileEntry[] => {
  return Array.from(files ?? []).map((file) => ({
    file,
    name: file.name,
    localUrl: URL.createObjectURL(file),
    path: prependRandomText ? `${Math.random().toString().slice(2)}_` + `${path}/${file.name}` : `${path}/${file.name}`,
  }));
};

const getChildPath = (path: string) => storageRef.child(path);
const getDownloadedUrl = (path: string) => getChildPath(path).getDownloadURL();

export const handleUploadFilesToStorage = async (entries: ILocalFileEntry[]): Promise<IUploadedFileEntry[]> => {
  const uploadedFiles: IUploadedFile[] = [];
  for await (const entry of entries) {
    try {
      const fileRef = getChildPath(entry.path);
      const snapshot = await fileRef.put(entry.file);
      const src = await getDownloadedUrl(snapshot.metadata.fullPath);
      uploadedFiles.push({
        src,
        path: snapshot.metadata.fullPath,
      });
    } catch (ex: any) {
      throw new Error(ex.message);
    }
  }
  return uploadedFiles;
};
